module.exports = __webpack_public_path__ + "91dc585cde955ad7add080c918bc8243.png";